import React from 'react';

import { Box } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import CollapsedBreadcrumbs from 'common/components/CollapsedBreadcrumbs';

import * as actions from '../actions';

const BranchOfficeName = ({ handleClickBreadcrumb, pl, reportDetails }) => {
    return (
        <Box sx={{ width: '100%', pl: { md: pl } }}>
            <CollapsedBreadcrumbs
                current={reportDetails?.name || ''}
                locations={[
                    {
                        label: reportDetails?.project?.name || '',
                        action: () =>
                            handleClickBreadcrumb(
                                reportDetails?.credit_product,
                            ),
                    },
                ]}
            />
        </Box>
    );
};

const mapDispatchToProps = (dispatch) => ({
    handleClickBreadcrumb: (creditId) =>
        dispatch(actions.handleClickBreadcrumb(creditId)),
});

BranchOfficeName.propTypes = {
    handleClickBreadcrumb: PropTypes.func,
    pl: PropTypes.number,
    reportDetails: PropTypes.object,
};

export default connect(null, mapDispatchToProps)(BranchOfficeName);
